import moment, { Moment } from 'moment';

export enum DueDateStatus {
  Default = 'default',
  Attention = 'attention',
  Overdue = 'overdue',
}

export const status = (timestamp: Moment): DueDateStatus => {
  if (timestamp.endOf('day').isBefore(moment().endOf('day'))) {
    return DueDateStatus.Overdue;
  }
  if (
    timestamp.endOf('day').isSameOrAfter(moment().startOf('day')) &&
    timestamp.endOf('day').isSameOrBefore(moment().add(2, 'day').endOf('day'))
  ) {
    return DueDateStatus.Attention;
  }

  return DueDateStatus.Default;
};
